const PREFIX = 'museum918:'

export const storageService = {
  get<T>(key: string, fallback: T): T {
    try {
      const value = localStorage.getItem(PREFIX + key)
      return value ? JSON.parse(value) as T : fallback
    } catch {
      return fallback
    }
  },
  set<T>(key: string, value: T) {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
  },
  remove(key: string) {
    localStorage.removeItem(PREFIX + key)
  },
  clearAccount() {
    Object.keys(localStorage).filter((key) => key.startsWith(PREFIX)).forEach((key) => localStorage.removeItem(key))
  },
}

export const generateUsername = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const length = 8 + Math.floor(Math.random() * 3)
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('')
}

export const formatToday = () => new Intl.DateTimeFormat('zh-CN', {
  year: 'numeric', month: 'long', day: 'numeric', weekday: 'short', timeZone: 'Asia/Shanghai',
}).format(new Date())
